import { render } from "./BrowseBar.vue?vue&type=template&id=be94a5f8"
import script from "./BrowseBar.vue?vue&type=script&lang=js"
export * from "./BrowseBar.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__